<template>
    <Icon>
        <template v-slot:component="svgProps">
            <InlineSvg :src="srcComputed" v-bind="svgProps"></InlineSvg>
        </template>
    </Icon>
</template>

<script>
import { computed, defineComponent } from "vue";
import Icon from "@ant-design/icons-vue";
import InlineSvg from "vue-inline-svg";

export default defineComponent({
    components: {
        Icon,
        InlineSvg,
    },
    props: {
        //dir: { default: "../../assets/icon" }, when :src="require(`${dir}/${file}`)" we got error. Why ??????
        file: { default: "unknow.svg" },
    },
    setup(props) {
        const srcComputed = computed(() => {
            try {
                return require(`../../assets/icon/${props.file}`);
            } catch (error) {
                return require(`../../assets/icon/not-found.svg`);
            }
        });
        return { srcComputed };
    },
});
</script>
